<template>
  <el-card class="card-main ">
    <div class="main">
      <el-form ref="searchInfo" class="global-form" :inline="true">
        <el-form-item>
          <el-select v-model="info.projectId" placeholder="请选择所属项目" filterable clearable>
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- <el-date-picker
            v-model="info.dailyDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日报日期">
          </el-date-picker> -->
          <el-date-picker class="picker" v-model="datePicker" type="daterange" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="mb20">
        <!-- <el-button type="primary" icon="el-icon-plus" @click="onAdd"  v-show="$ButtonShow('YPDA_ADD_01')">新增</el-button> -->
        <el-button type="primary" icon="el-icon-plus" @click="goDailyTemplate"
          v-show="$ButtonShow('YDT_ADD_01')">日报模板</el-button>
        <CustomExport type="13" :params="{ ...info }" v-show="$ButtonShow('YPDA_SEL_18')">导出</CustomExport>
      </div>
      <!-- max-height="550px" -->
      <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData">
        <el-table-column label="项目名称" min-width="80px" show-overflow-tooltip prop="projectName">
        </el-table-column>
        <el-table-column label="日报日期" min-width="80px" show-overflow-tooltip prop="dailyDate">
        </el-table-column>
        <el-table-column label="填报人" min-width="70px" show-overflow-tooltip prop="dailyUserName">
        </el-table-column>
        <el-table-column label="填报时间" min-width="60px" show-overflow-tooltip prop="ctime">
        </el-table-column>
        <el-table-column label="客户评分" min-width="60px" show-overflow-tooltip prop="avgGrade">
        </el-table-column>
        <el-table-column label="操作" width="180px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetail(row.dailyId, row.projectId)">查看</el-button>
            <el-button type="text" @click="onEdit(row.dailyId, row.projectId, row.dailyDate)"
              v-show="$ButtonShow('YDT_EDT_01') && isToday(row.dailyDate)">编辑</el-button>
            <el-button type="text" @click='onDelete(row.dailyId)' v-show="$ButtonShow('YPDA_DEL_01')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <Add :addShow.sync="addShow"  @success="loadData" :id.sync = id></Add> -->
      <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
        @size-change="loadData"></global-pagination>

      <ReportDetail v-if="dailyId" :otherProjectId="otherProjectId" :dailyId="[dailyId]" :isShow.sync="showDetail">
      </ReportDetail>
    </div>
  </el-card>
</template>

<script>
// import Add from './Add.vue'
import ReportDetail from '@/views/workPlan/ReportDetail'
export default {
  name: 'maintenanceDay',
  components: { ReportDetail },
  data() {
    return {
      showDetail: false,
      dailyId: '',
      otherProjectId: '',
      info: {
        projectId: '',
        dailyDate: '',
        startTime: '',
        endTime: ''
      },
      addShow: false,
      id: '',
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      datePicker: []
    }
  },

  computed: {

    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
    showDetail(val) {
      if (!val) {
        this.dailyId = ''
      }
    }
  },

  created() {
    if (this.$route.query.projectId || this.$route.query.startTime && this.$route.query.endTime) {
      this.info.projectId = this.$route.query.projectId
      this.info.startTime = this.$route.query.startTime
      this.info.endTime = this.$route.query.endTime
      this.datePicker = [this.$route.query.startTime, this.$route.query.endTime]
    }
    this.loadData()
  },
  methods: {

    dateChange(val) {
      console.log(val);
      if (val) {
        this.info.startTime = val[0]
        this.info.endTime = val[1]
      } else {
        this.info.startTime = ''
        this.info.endTime = ''
      }
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },

    loadData() {
      this.loading = true
      this.$axios
        .get(
          this.$apis.maintenanceDaily.selectYhProjectDailyByPage,
          {
            ...this.info,
            page: this.page,
            size: this.size
          }
        )
        .then((res) => {
          if (res) {
            this.total = res.total || 0
            this.tableData = res.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    isToday(today) {
      const date = this.$dayjs().format('YYYY-MM-DD')
      if (today === date) {
        return true
      } else {
        return false
      }
    },

    // 新增
    onAdd() {
      // console.log('新增')
      // this.$router.push({ name: 'addTeams' })
      this.addShow = true
    },

    // 查看
    onDetail(id, projectId, dailyDate) {
      this.dailyId = id
      this.otherProjectId = projectId
      this.$nextTick(() => {
        this.showDetail = true
      })
      // this.$router.push({
      //   path: '/maintenanceDaily/details',
      //   query: {
      //     dailyId: id,
      //     projectId,
      //     dailyDate
      //   }
      // })
    },

    onEdit(id, projectId, dailyDate) {
      this.$router.push({
        path: '/maintenanceDaily/edit',
        query: {
          dailyId: id,
          projectId,
          dailyDate
        }
      })
    },

    // 删除
    onDelete(dailyId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$axios.post(this.$apis.maintenanceDaily.deleteYhProjectDaily, { dailyId }).then(() => {
            this.$message.success('删除成功')
            this.onSearch()
          }).finally(() => {
            this.loading = false
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },

    goDailyTemplate() {
      this.$router.push({
        path: '/maintenanceDaily/DailyTemplate'
      })
    }
  }

}
</script>

<style scoped lang="scss">
// .main {
//   width: 100%;
//   padding: 0px 10px;
// }
::v-deep .el-card {
  width: 100% !important;
  height: 100% !important;
  margin-top: 20px !important;
}

::v-deep .el-table__body-wrapper {
  // overflow-y:hidden;
}

.button-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
</style>
